<div style="color:white;padding:0;margin:0;text-align: center;overflow: scroll;scrollbar-width: none;" class="mat-app-background"
     [style.min-height]="height" [style.width]="width">
  <router-outlet></router-outlet>
</div>
